import { NavigationOverrides } from '../NavigationContext';
import { useCurrentLocation } from './useCurrentLocation';
import { isRevenueLocation } from '../utils/isRevenueEnvironment';
export const GENERIC_VARIANT = 'GENERIC';
export type NavigationVariant = 'billing' | 'revenue' | typeof GENERIC_VARIANT;

export const useNavigationVariant = ({
  variant: variantOverride,
}: NavigationOverrides = {}): NavigationVariant => {
  const currentLocation = useCurrentLocation();

  const getVariant = (): NavigationVariant => {
    if (isRevenueLocation(currentLocation)) {
      return 'revenue';
    }

    return 'billing';
  };

  return variantOverride ?? getVariant();
};
